/* eslint-disable no-mixed-spaces-and-tabs */
import { React } from 'react';
import { EmailView } from '@/components/views/EmailView';

export const TemplatesPage = () => {
	return <EmailView />;
};
